import React from "react";
import useGroupOrder, { GROUP_ORDER_BUFFER } from "./useGroupOrder";
import EmojiConfirmPopup from "../components/EmojiConfirmPopup";
import i18n from "../Helpers/i18n";
import TimeslotPopup from "../components/TimeslotPopup";
import { Promo } from "../components/Notifications/Promo";

const GroupOrder = ({ children }) => {
    const {
        memberGroupOrderTimeOut,
        setMemberGroupOrderTimeOut,
        setOwnerGroupOrderTimeOut,
        ownerGroupOrderTimeOut,
        timeslotPopupOpen,
        leaveParticipant,
        setOpenTimeslotPopup,
        earliestTimeslot,
        ownerChangeTimeSlot,
        onTimeslotUpdate,
        abortGroupOrder,
    } = useGroupOrder();
    return (
        <div>
            {children}
            <div>
                <EmojiConfirmPopup
                    open={memberGroupOrderTimeOut}
                    setOpen={setMemberGroupOrderTimeOut}
                    emoji={"⏰"}
                    title={i18n.t(`memberGroupOrderTimeOut.title`)}
                    infoText={i18n.t(`memberGroupOrderTimeOut.description`)}
                    twoBtns={false}
                    closeBtnText={i18n.t(`memberGroupOrderTimeOut.closeBtn`)}
                    onConfirm={leaveParticipant}
                />

                <EmojiConfirmPopup
                    open={ownerGroupOrderTimeOut}
                    setOpen={setOwnerGroupOrderTimeOut}
                    emoji={"😪"}
                    title={i18n.t(`ownerGroupOrderTimeOut.tempTitle`)}
                    infoText={i18n.t(`ownerGroupOrderTimeOut.tempDescription`)}
                    closeBtnText={i18n.t(`ownerGroupOrderTimeOut.tempCancel`)}
                    ctaText={i18n.t(`ownerGroupOrderTimeOut.changeTimeSlotBtn`)}
                    closeBtnVariant={"danger"}
                    ctaBtnVariant={"primary"}
                    onConfirm={ownerChangeTimeSlot}
                    onCancel={() => {
                        abortGroupOrder();
                        window.location.href = window.location.pathname;
                    }}
                    twoBtns={true}
                    closable={false}
                />

                <TimeslotPopup
                    popupOpen={timeslotPopupOpen}
                    setOpen={setOpenTimeslotPopup}
                    handleSubmit={({ slot, earlyOnLocation }) => {
                        onTimeslotUpdate({ slot, earlyOnLocation });
                        window.location.href = window.location.pathname;
                    }}
                    firstAvailableId={earliestTimeslot?.id}
                    buffer={GROUP_ORDER_BUFFER}
                />
            </div>
            <Promo />
        </div>
    );
};

export default GroupOrder;
